export const filterRegions = ["全部", "中国大陆", "中国香港", "美国", "日本", "韩国", "英国", "新西兰"];

export const filterYears = ["全部", "2024", "2023", "2022"];

export const filterLanguages = ["全部", "国语", "粤语", "英语", "日语", "韩语"];

export const filterSorts = [
  { value: "hot", label: "热度" },
  { value: "new", label: "最新" },
  { value: "rating", label: "评分" },
];

export const popularKeywords = ["科幻", "古装", "悬疑", "美食", "音乐", "战争"];